<template>
  <div
    id="side-menu"
    :style="{
      backgroundImage: `url(${require('@/assets/images/planters.png')})`
    }"
  >
    <div class="p-4" align="right">
      <router-link to="/">
        <img
          class="mt-2"
          :src="require('@/assets/icons/logo-light.svg')"
          height="45px"
          alt=""
        />
      </router-link>
    </div>

    <div align="right" class="pad-rgt-20">
      <div class="bg-light avatar-wrapper d-flex shadow-xl">
        <img
          class=""
          style="width: 100%;height: 100%"
          :src="
            userObj.photourl ||
              `https://ui-avatars.com/api/?name=${userObj.firstname}+${userObj.lastname}&color=F5AA41&bold=true&rounded=true`
          "
          id="user-logo"
        />
      </div>
    </div>

    <h6 align="right" class="pad-rgt-20" style="margin-top: 10px">
      <span class="text-white-50">Hi,</span>
      <span class="text-white ml-2">{{ userObj.firstname }}</span>
    </h6>

    <div class="mt-4">
      <ul class="list-unstyled">
        <li v-for="menu in menuLinks" :key="menu.name" align="right">
          <b-button :to="menu.link" class="w-100 text-left py-3">
            <div class="menu-ic">
              <i :class="menu.icon"></i>
            </div>
            <div style="float:right">
              <b-badge class="ml-2 mr-2" variant="warning" v-if="menu.new"
                >New</b-badge
              >{{ menu.name }}</div>
            <div style="clear:both"></div>
          </b-button>
        </li>
        <li>
          <b-button class="w-100 text-left py-3" @click="openSupport()">
            <div class="menu-ic"><i class="fa fa-headset"></i></div>
            <div style="float:right">Support</div>
            <div style="clear:both"></div>
          </b-button>
        </li>
        <li>
          <b-button class="w-100 text-left py-3" @click="logout">
            <div class="menu-ic"><i class="ti-power-off"></i></div>
            <div style="float:right">Logout</div>
            <div style="clear:both"></div>
          </b-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      menuLinks: [
        { name: "Dashboard", link: "/dashboard", icon: "fa fa-home" },
        { name: "Farm Funding", link: "/farms/funding", icon: "fa fa-chart-line" },
        { name: "Farm Ownership", link: "/farms/ownership", icon: "fa fa-map"},
        { name: "Farm For Me", link: "/farms", icon: "fa fa-seedling"},
        { name: "Edibles", link: "/edibles", icon: "fas fa-luggage-cart", new: true  },
        {
          name: "Wallet",
          link: "/wallet",
          icon: "fa fa-credit-card"
        },
        //{ name: "Sales", link: "/sales", icon: "fa fa-shopping-basket" },
        //{ name: "Rentals", link: "/rentals", icon: "fa fa-scissors" },
        { name: "Referrals", link: "/referrals", icon: "fa fa-sitemap" },
        {
          name: "Manage Profile",
          link: "/profile",
          icon: "fa fa-drivers-license"
        }
      ]
    };
  },
  computed: {
    ...mapState(["userObj"])
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    openSupport() {
      try {
        this.$drift.openSideBar();
      } catch (error) {
        //console.log(error);

        return;
      }
    }
  }
};
</script>

<style lang="scss">
#side-menu {
  display: none;
  position: fixed;
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: contain;
  height: 100vh;
  background-color: #316001;

  .router-link-exact-active {
    border: none;
    color: #85c341 !important;
    font-weight: 700;
    border-radius: 0;
    background-color: #edf2f7 !important;
    border-right: solid 1px #316001 !important;
  }

  .pad-rgt-20 {
    padding-right: 20px !important;
  }

  .avatar-wrapper {
    height: 50px;
    width: 50px;
  }

  .router-link-exact-active i {
    color: #85c341 !important;
  }

  .btn.w-100.text-left.py-3.btn-secondary {
    text-align: right !important;
    font-size: 15px;
  }

  .menu-ic {
    float: right;
    margin-left: 10px;
  }

  .menu-ic i {
    font-size: 15px;
    color: #efefef;
  }

  .list-unstyled,
  .list-unstyled li a,
  .w-100.text-left.py-3 {
    background-color: #316001;
    border: none;
    border-bottom: solid 1px #356701;
  }

  .list-unstyled,
  .list-unstyled li a:hover,
  .w-100.text-left.py-3:hover {
    background-color: #6b9e35;
  }

  .list-unstyled,
  .list-unstyled li a:hover,
  .w-100.text-left.py-3:hover {
    background-color: #608e2f;
  }

  .nav-item > a.router-link-active {
    background-color: #edf2f7;
    border-radius: 15px 0px 0px 15px;
  }

  .user-avatar-holder {
    border-radius: 50% 0px 0px 50%;
  }

  .nav-link {
    width: 100px;
    border-radius: 15px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
  #side-menu {
    width: 0px;
  }
  #main-app {
    margin-left: 0px;
  }
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  #main-app {
    margin-left: 130px;
  }
  #side-menu {
    display: block;
    width: 130px;
    .nav-link {
      width: 70px;
      border-radius: 15px;
    }
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  #main-app {
    margin-left: 200px;
  }
  #side-menu {
    width: 200px;
    .nav-link {
      width: 180px;
      border-radius: 15px;
    }
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  #main-app {
    margin-left: 250px;
  }
  #side-menu {
    width: 250px;
    .nav-link {
      width: 180px;
      border-radius: 15px;
    }
  }
}
</style>
